(() => {
	angular
		.module('main')
		.directive('chooseSubscriptionModal', chooseSubscriptionModal);

	chooseSubscriptionModal.$inject = [
		'accountService',
		'userService',
		'subscriptionService'
	];

	function chooseSubscriptionModal(
		accountService,
		userService,
		subscriptionService
	) {
		return {
			restrict: 'E',
			scope: {},
			template: `
                     <div class="modal modal-center modal-subscription fade" id="subscriptionModal" tabindex="-1" role="dialog"
                         aria-labelledby="myModalLabel" aria-hidden="true"
                         data-backdrop="static" data-keyboard="false">
                        <div class="dashboard-subscription-modal modal-dialog">
                            <div class="modal-content modal-banner">
                                <div class="modal-header">
                                    <btn-close></btn-close>
                                    <h3 class="modal-title">Choose your subscription</h3>
                                </div>
                                <div class="modal-body">
                                    <div class="row flex-row flex-align-center flex-wrap-xs mb-10 mt-5">
                                        <div class="col-xs-12 col-sm-3 col-md-3">
                                            <subscription-banner-list></subscription-banner-list>
                                        </div>
                                        <h2 class="col-xs-12 visible-xs-block"></h2>
                
                                        <div class="col-xs-12 col-sm-9 plans-list">
                                        
                                           <subscription-annual-discount ng-show="isAnnualDiscount"
                                                                              ng-click="subscribeStripeModal('annual', $event)"
                                           ></subscription-annual-discount>
                                           
                                           <subscription-monthly-discount ng-show="isMonthlyDiscount" 
                                                                               ng-click="subscribeStripeModal('monthly', $event)"
                                           ></subscription-monthly-discount>
                                           
                                           <subscription-annual ng-hide="isAnnualDiscount" 
                                                                ng-click="subscribeStripeModal('annual', $event)"
                                           ></subscription-annual>
                                           
                                           <subscription-monthly ng-hide="isMonthlyDiscount"
                                                                 ng-click="subscribeStripeModal('monthly', $event)"
                                           ></subscription-monthly>
                                            
                                        </div>
                
                                        <h2 class="col-xs-12 visible-xs-block"></h2>
                                        <div class="col-xs-12 col-sm-4 modal-banner-donate flex-row flex-wrap">
                                            <div class="modal-banner-donate__picture">
                                                <img src="https://app.studioninja.co/build/master-59/resources/dist/assets/images/photos/donate.png" alt="donate">
                                                <img class="ygap-logo" src="https://app.studioninja.co/build/master-59/resources/dist/assets/images/ygap.png" alt="ygap-logo">
                                            </div>
                                            <div class="modal-banner-donate__description">
                                            	We donate $1 of every subscription payment, every month to YGAP. Our mission?
                                            	To help YGAP change the lives of <b>one million people</b> living in poverty by 2019.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                
                        </div>
                    </div> 
                `,
			replace: true,
			transclude: true,
			controller: 'SubscriptionController',
			link(scope) {
				scope.unsubscribe = new Rx.Subject();

				getUser();

				scope.$on('$destroy', () => {
					scope.unsubscribe.next();
					scope.unsubscribe.complete();
				});

				scope.subscribeStripeModal = function(plan, e) {
					subscriptionService.subscribeStripeModalWeb(plan, e);
				};

				function getUser() {
					accountService.userDataObservable.subscribe(user => {
						if (user !== null && typeof user !== 'undefined') {
							if (!userService.subscriptionData) {
								return;
							}
							const {
								monthlyDiscount,
								annualDiscount
							} = userService.subscriptionData;
							scope.isAnnualDiscount = annualDiscount;
							scope.isMonthlyDiscount = monthlyDiscount;
						}
					});
				}
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Subscription/Modals/chooseSubscriptionModal.js